<template>
	<article class="still">
		<Tinybox v-model="index" :images="tinyImages" no-thumbs />
		<div
			v-for="(image, idx) in images"
			class="still__box open-tinybox"
			:key="image.id"
			@click="index = idx"
		>
			<!-- <div class="plus"></div> -->
			<img :src="$getImgUrl(image.name)" :alt="image.name" />
		</div>
		<div
			v-if="project.description"
			class="still__box still__box-text"
			v-html="project.description"
			ref="description"
		></div>
		<div class="still__last"></div>
		<router-link to="/still" tag="button" class="button__primary">
			back to projects
		</router-link>
	</article>
</template>
<script>
import Tinybox from 'vue-tinybox'
export default {
	components: {
		Tinybox
	},
	data: ({ $route }) => ({
		slug: $route.params.project,
		project: null,
		images: [],
		index: null,
		tinyImages: []
	}),
	created() {
		const index = this.$store.getters['project/data'].findIndex(
			(item) =>
				item.name
					.split(' ')
					.join('-')
					.toLowerCase() === this.slug
		)
		if (index > -1) {
			this.project = this.$store.getters['project/data'][index]
			this.images = [
				...this.$store.getters['image/data'].filter(
					(item) => +item.projectId === +this.project.id
				)
			].sort(this.$compareValues('order'))
			this.tinyImages = this.images.map((item) => ({
				src: this.$getImgUrl(item.name)
			}))
		} else {
			this.$router.replace('/404')
		}
	},
	mounted() {
		this.styleDescription()
	},
	methods: {
		getName(id) {
			const index = this.$store.getters['image/data'].findIndex(
				(i) => i.id === +id
			)
			return this.$store.getters['image/data'][index].name
		},
		styleDescription() {
			if (this.$refs.description) {
				this.$refs.description.children.forEach((item) => {
					if (Object.entries(item.dataset).length) {
						const result = Object.keys(item.dataset).map((key) => [
							key,
							item.dataset[key]
						])
						result.forEach((i) => {
							item.style[i[0]] = i[1]
						})
					}
				})
			}
		}
	}
}
</script>
